import { ApolloClient, InMemoryCache } from '@apollo/client';
import Config from '../config';

export function createGraphqlClient(accessToken) {
  const graphqlClient = new ApolloClient({
    uri: Config.graphqlUrl(),
    cache: new InMemoryCache(),
    headers: {
      authorization: `Bearer ${accessToken}`,
    },
  });
  return graphqlClient;
}
